import { useLayoutEffect } from "react";
import { selectFonts } from "../store/forms/selectors";
import { IFont } from "../store/forms/types";

import useShallowSelector from "./useShalowSelector";

type IUseStyle = () => {
    fonts: IFont[];
};

export type IMIXED_VALUE = "MIXED_VALUE";
export const MIXED_VALUE: IMIXED_VALUE = "MIXED_VALUE";

export const useFonts: IUseStyle = () => {
    const fonts = useShallowSelector(selectFonts);

    useLayoutEffect(() => {
        const head = document.querySelector("head");

        fonts?.forEach(font => {
            if (document.getElementById(font.family.replace(" ", "+"))) return;
            const link = document.createElement("link");
            link.href = "https://fonts.googleapis.com/css2?family=" + font.family;
            link.rel = "stylesheet";
            link.id = font.family.replace(" ", "+");
            head?.appendChild(link);
        });
    }, [fonts]);

    return {
        fonts,
    };
};
